import Feature from 'ol/Feature';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'client/components/aria/Button/Button';
import styles from './FeaturePanelOpenButton.module.scss';
import { setSelected } from 'client/store/mapSlice/mapSlice';

const FeaturePanelOpenButton = ({ feature, openIntlId, closeIntlId, ...props }) => {
    const dispatch = useDispatch();
    const openFeatures = useSelector(state => state.map?.selected || []);
    const myId = feature.getProperties().dataproviderassigneduniqueid;
    const isFeatureOpen = openFeatures.some(openFeature => openFeature.getProperties().dataproviderassigneduniqueid === myId);

    const toggleFeatureOpen = () => {
        dispatch(setSelected(isFeatureOpen ? [] : [feature]));
    };

    return <Button variant='info' onPress={toggleFeatureOpen} className={styles.panelButton} data-testid={props['data-testid']}>
        <FormattedMessage id={isFeatureOpen ? closeIntlId : openIntlId} />
    </Button>;
};

FeaturePanelOpenButton.propTypes = {
    feature: PropTypes.instanceOf(Feature).isRequired,
    openIntlId: PropTypes.string,
    closeIntlId: PropTypes.string,
    'data-testid': PropTypes.string
};

FeaturePanelOpenButton.defaultProps = {
    openIntlId: 'openFeaturePanel.openFeature',
    closeIntlId: 'openFeaturePanel.closeFeature',
    'data-testid': 'FeaturePanelOpenButton.button'
};

export default FeaturePanelOpenButton;
